import styled from "styled-components";
import { device } from "../device";
import PropTypes from "prop-types";

const UnderlineLink = styled.a`
    border-bottom: 2px solid var(--green1);
    display: initial;
    font-weight: 500;
    font-size: ${({size}) => 
        size === 'medium' ? '18px' : '16px'
    };
	position: relative;
    transition: color .15s ease-in-out;
    &:hover,
    &:focus {
        color: var(--green1);
    }
    @media ${device.lg} {
        font-size: ${({size}) => 
            size === 'medium' ? '24px' : '16px'
        };
    }
`;

UnderlineLink.propTypes = {
    size: PropTypes.string
};

export default UnderlineLink;